module.exports = __webpack_public_path__ + "img/Pot3.a02fefbf.svg";